export class PrepayFilter {
  accountNo: string;
  accountName: string;
  prepayType: string;
}
